import { useQuery } from '@tanstack/react-query';
import { XHRAuthorizedClient } from '../client';
import { ENDPOINTS } from '../endpoints';
import { QUERY_KEYS } from '../query-key';

interface Response {
  success: boolean;
  data: {
    isDuplicate: boolean;
    siteId: string;
  };
  message: string;
}

export const useCheckDuplication = (
  siteId: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.sites.checkDuplication, siteId],
    queryFn: async (): Promise<boolean> => {
      const response = await XHRAuthorizedClient.get<Response>(
        ENDPOINTS.sites.checkDuplication(siteId)
      );
      return response.data.data.isDuplicate;
    },
    enabled: options?.enabled !== false && Boolean(siteId),
  });
};
